import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Checkbox from '@/src/components/common/Checkbox/Checkbox';
import { RootState } from '@/src/reducers/types';

type SelectAllCheckboxProps = {
  flatFiles: Array<{ id: string | number }>;
  enableCondition?: (
    files: RootState['files'],
    flatFiles: Array<{ id: string | number }>
  ) => boolean;
};

const SelectAllCheckbox = ({ flatFiles, enableCondition }: SelectAllCheckboxProps) => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);

  if (flatFiles.length < 1) {
    return null;
  }

  const isEnabled =
    typeof enableCondition === 'function'
      ? enableCondition(files, flatFiles)
      : flatFiles.length > 0;

  const allSelected =
    flatFiles.length > 0 &&
    flatFiles.every((file) => files.selectedItems.some((f) => f.id === file.id));

  const handleSelectAll = () => {
    const newSelection = allSelected ? [] : flatFiles;
    dispatch({
      type: 'UPDATE_SELECTED_ITEMS',
      selectedItems: newSelection,
    });
  };

  return <Checkbox checked={allSelected} onChange={handleSelectAll} disabled={!isEnabled} />;
};

export default SelectAllCheckbox;
